export const CURRENCY_SIGN = {
  AUD: { prefix: "$", suffix: "" },
  USD: { prefix: "$", suffix: "" },
  PLN: { prefix: "", suffix: "zł" },
};

/**
 * Unfortunately chargebee doesn't allow us to store images with addons
 */
export const PRODUCT_IMAGES = {
  RAY: require("../assets/ray_small.jpg"),
  ADAPTER: require("../assets/adapter.png"),
  SUBSCRIPTION: require("../assets/subscription.png"),
};

export const productsConverter = (allProducts, selected) => {
  const checkoutProducts = [];
  let sum = 0;
  for (const key of selected) {
    const product = allProducts.find((el) => el.id === key);
    if (product) {
      let image = PRODUCT_IMAGES.SUBSCRIPTION;

      if (product.id.includes("adapter")) {
        image = PRODUCT_IMAGES.ADAPTER;
      } else if (product.id.includes("ray")) {
        image = PRODUCT_IMAGES.RAY;
      }
      console.log(
        product.id,
        product.id.includes("adapter"),
        product.id.includes("ray")
      );
      console.log(
        product.id,
        product.id.includes("adapter"),
        product.id.includes("ray"),
        image
      );
      checkoutProducts.push({
        ...product,
        sign: CURRENCY_SIGN[product.currency] || {
          prefix: product.currency,
          suffix: "",
        },
        originalPrice: product.price / 100,
        price: product.price / 100,
        image,
      });
      sum += product.price;
    }
  }
  return [checkoutProducts, sum / 100];
};

export const getChargebee = () => {
  var chargebee = require("chargebee");
  chargebee.configure({
    site: process.env.VUE_APP_CHARGEBEE_SITE,
    api_key: process.env.VUE_APP_CHARGEBEE_KEY,
  });

  return chargebee;
};

export const createSubscription = async (
  formData,
  settings,
  products,
  paymentData,
  paypalExpress = {}
) => {
  const chargebee = getChargebee();
  return new Promise((resolve, reject) => {
    chargebee.subscription
      .create({
        ...paypalExpress,
        plan_id: settings.plan,
        auto_collection: "on",
        card: {
          gateway_account_id: process.env.VUE_APP_CHARGEBEE_PAYMENT_GATEWAY,
          ...paymentData,
        },
        coupon_ids: [settings.plan],
        billing_address: {
          first_name: formData.firstName,
          last_name: formData.lastName,
          line1: formData.address,
          line2: formData.apartment,
          state_code: formData.stateCode,
          state: formData.state,
          city: formData.city,
          zip: formData.postalCode,
          country: formData.country,
        },
        customer: {
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          locale: "en-US",
          company: formData.company,
          phone: formData.phone,
        },
        addons: products
          .filter((p) => p.id !== plan_id)
          .map((p) => {
            return { id: p.id, quantity: 1 };
          }),
      })
      .request(function (error, result) {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      });
  });
};
